import { createContext } from "react";

const PageContext = createContext();

export default PageContext;